import styled from "@emotion/styled"
import tw from "twin.macro"

import { StyledButton } from "../Styled/Button"

export const ContentButton = styled(StyledButton)`
  ${tw`font-normal normal-case`}
  font-size: inherit;
`
